import React from 'react';

const PatientPayment: React.FC = () => {
  return (
    <div>
      <h1>Patient Payment</h1>
      <p>Pay for consultative services easily and securely.</p>
      <form>
        <label>
          Patient Name:
          <input type="text" name="patientName" />
        </label>
        <br />
        <label>
          Payment Amount:
          <input type="number" name="amount" />
        </label>
        <br />
        <button type="submit">Submit Payment</button>
      </form>
    </div>
  );
};

export default PatientPayment;
